import { render, staticRenderFns } from "./RaicProcedure.vue?vue&type=template&id=45ddd2f9"
import script from "./RaicProcedure.vue?vue&type=script&lang=js"
export * from "./RaicProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports